﻿import React, { useState, useEffect } from 'react';
import ImageHandler from './ImageHandler';
import DocumentLoader from './DocumentLoader';
//import { Document } from '../models/document';
//import { AttachedImage } from '../models/attached-image';
//import { LookupItem } from '../models/lookup-item';
import { BenchSheetTechnologyType, DocumentType } from '../models/enums';

export interface Props {
    parentId: string;
    technology?: BenchSheetTechnologyType;
    documentType?: DocumentType;
    imageTypes?: string;
    imageHandlerTitle?: string;
    hideImageHandler?: boolean;
    readOnly?: boolean;
    canDelete?: boolean;
}

export default function BenchSheetData(props: Props) {
    return (
        <div id="mobilePhasePreparationPanel">
            <div className="lq-header pw-margin-top-05 aurum-blue-bg">
                <div className="lq-header-title">Image and Data Attachments</div>
            </div>

            <div className="pw-form-section">
                <div className="pw-margin-left-1 pw-margin-right-1">
                    {!props.hideImageHandler &&
                        <ImageHandler parentId={props.parentId}
                            readOnly={props.readOnly} canDelete={props.canDelete}
                            technology={props.technology}
                            title={props.imageHandlerTitle} />
                    }

                    <div className="lq-sub-title pw-margin-top-1 pw-margin-bottom-05">Other Documents</div>

                    <DocumentLoader parentId={props.parentId}
                        technology={props.technology}
                        documentType={props.documentType}
                        readOnly={props.readOnly} canDelete={props.canDelete} />

                </div>
            </div>
        </div>
    );
}

